import React from "react";
import { IKImage } from "imagekitio-next";

type ContactImagePropsType = {
  imageName?: string;
  imageUrl?: string;
  alt: string;
  className?: string;
};

const urlEndpoint = process.env.NEXT_PUBLIC_BASE_IMAGE_KIT_URL;

const ContactImage = ({ imageName, imageUrl, alt, className = "" }: ContactImagePropsType) => {
  return (
    <IKImage
      src={imageUrl || `${urlEndpoint}${imageName || "default_image.jpg"}`}
      key={imageUrl}
      urlEndpoint={urlEndpoint}
      transformation={[{ crop: "maintain_ratio" }]}
      width={500}
      height={500}
      alt={alt}
      lqip={{ active: true, quality: 20 }}
      loading="lazy"
      className={className}
    />
  );
};

export default ContactImage;
